interface CalendarDateEntryHeaderProps {
  header: {
    label: string;
    onPrev: () => void;
    onNext: () => void;
  };
}
export const CalendarDateEntryHeader = ({
  header,
}: CalendarDateEntryHeaderProps) => {
  const { monthLabel, handleClickPrevMonth, handleClickNextMonth } = {
    monthLabel: header?.label ?? '',
    handleClickPrevMonth: header?.onPrev,
    handleClickNextMonth: header?.onNext,
  };
  return (
    <div className={'calendar-date-header'}>
      <div className={'month-label'}>
        <span>{monthLabel}</span>
      </div>
      <div className={'month-selector'}>
        <div className={'left-month-icon'} onClick={handleClickPrevMonth}>
          <i className={'icon-image'} />
        </div>
        <div className={'right-month-icon'} onClick={handleClickNextMonth}>
          <i className={'icon-image'} />
        </div>
      </div>
    </div>
  );
};
